(function () {
	'use strict';
	angular.module('app.core')
		.service('inventoryActionsService', inventoryActionsService);

	inventoryActionsService.$inject = ['formatterService', '$http', 'URLS', '$experiments'];
	function inventoryActionsService(formatterService, $http, URLS, $experiments) {
		var recommendationMap = {
			'MRPResize': getMrpRecommendationText,
			'VMILevel': getVmiLevelRecommendationText,
			'POForExcess': getPOForExcessRecommendationText,
			'ROPResize': getRopResizeRecommendationText,
			'ExcessToSell': getExcessToSellRecommendationText,
			'POForExcessLeadTime': getPOForExcessLeadTimeRecommendationText,
			'PoReduction': getPoReductionRecommendationText
		};

		return {
			getRecommendationByType: getRecommendationByType,
			getHistory: getHistory,
			saveInventoryActionValidSavings: saveInventoryActionValidSavings,
			getDefaultEnabledActions: getDefaultEnabledActions
		};

		function getDefaultEnabledActions() {
			return ['VMILevel', 'ROPResize', 'ExcessToSell', 'PoReduction'];
		}

		function getRecommendationByType(type, details, siteId, status) {
			if (type && type.length && recommendationMap[type]) {
				return recommendationMap[type](details, siteId, status);
			}
		}

		function getMrpRecommendationText(details, siteId, status) {
			var recommendationText = '';
			switch (details.currentOrderPolicy) {
			case 'Fixed Lot Size':
				if ((status === 'Fixed' && (!details || !(details.previousLotSize || details.previousLotSize === 0)))
						|| (status === 'Expired' && (!details || !(details.previousProposedLotSize || details.previousProposedLotSize === 0)))) {
					recommendationText += 'Change fixed lot size';
				} else {
					var currentVariable = (status === 'Fixed' && (details.previousLotSize || details.previousLotSize === 0)
						? details.previousLotSize
						: details.currentLotSize);
					var proposedVariable = (status === 'Expired' && (details.previousProposedLotSize || details.previousProposedLotSize === 0)
						? details.previousProposedLotSize
						: details.proposedLotSize);
					recommendationText += 'Change fixed lot size from ' +
							formatterService.formatDecimal(currentVariable, 0) + ' to ' +
							formatterService.formatDecimal(proposedVariable, 0);
				}
				break;
			case 'Order Interval':
				if ((status === 'Fixed' && (!details || !(details.previousOrderInterval || details.previousOrderInterval === 0)))
						|| (status === 'Expired' && (!details || !(details.previousProposedOrderInterval || details.previousProposedOrderInterval === 0)))) {
					recommendationText += 'Change order interval';
				} else {
					var daysDisplayType = globalConfig.user.authFacts[siteId].daysDisplayType;
					var currentVariable = (status === 'Fixed' && (details.previousOrderInterval || details.previousOrderInterval === 0)
						? details.previousOrderInterval
						: details.currentOrderInterval);
					var proposedVariable = (status === 'Expired' && (details.previousProposedOrderInterval || details.previousProposedOrderInterval === 0)
						? details.previousProposedOrderInterval
						: details.proposedOrderInterval);
					var currentDisplay, proposedDisplay;
					if (daysDisplayType !== 'Calendar Days') {
						currentDisplay = formatterService.formatDecimal(currentVariable * 5 / 7, 0) + ' Work Days';
						proposedDisplay = formatterService.formatDecimal(proposedVariable * 5 / 7, 0) + ' Work Days';
					} else {
						currentDisplay = formatterService.formatDecimal(currentVariable, 0);
						proposedDisplay = formatterService.formatDecimal(proposedVariable, 0);
					}
					recommendationText += 'Change order interval from ' +
							currentDisplay + ' to ' + proposedDisplay;
				}
				break;
			case 'Lot By Lot':
				if ((status === 'Fixed' && (!details || !(details.previousLotByLotSize || details.previousLotByLotSize === 0)))
						|| (status === 'Expired' && (!details || !(details.previousProposedLotSize || details.previousProposedLotSize === 0)))) {
					recommendationText += 'Change lot size';
				} else {
					var currentVariable = (status === 'Fixed' && (details.previousLotByLotSize || details.previousLotByLotSize === 0)
						? details.previousLotByLotSize
						: details.currentLotByLotSize);
					var proposedVariable = (status === 'Expired' && (details.previousProposedLotSize || details.previousProposedLotSize === 0)
						? details.previousProposedLotSize
						: details.proposedLotSize);
					recommendationText += 'Change lot size from ' +
							formatterService.formatDecimal(currentVariable, 0) + ' to ' +
							formatterService.formatDecimal(proposedVariable, 0);
				}
				break;
			}
			return recommendationText;
		}

		function getVmiLevelRecommendationText(details) {
			var recommendationText = 'Change ';
			var hasValidMin = true;
			var hasValidMax = true;
			if ((status === 'Fixed' && (!details || !(details.previousMin || details.previousMin === 0)))
				|| (status === 'Expired' && (!details || !(details.previousRecommendedMin || details.previousRecommendedMin === 0)))) {
				hasValidMin = false;
			}
			if ((status === 'Fixed' && (!details || !(details.previousMax || details.previousMax === 0)))
				|| (status === 'Expired' && (!details || !(details.previousRecommendedMax || details.previousRecommendedMax === 0)))) {
				hasValidMax = false;
			}
			if (!hasValidMin && !hasValidMax) {
				recommendationText = 'Min Max Resize';
			} else {
				var minVariable = (status === 'Fixed' && (details.previousMin || details.previousMin === 0)
					? details.previousMin
					: details.currentMin);
				var proposedMinVariable = (status === 'Expired' && (details.previousRecommendedMin || details.previousRecommendedMin === 0)
					? details.previousRecommendedMin
					: details.recommendedMin);
				var maxVariable = (status === 'Fixed' && (details.previousMax || details.previousMax === 0)
					? details.previousMax
					: details.currentMax);
				var proposedMaxVariable = (status === 'Expired' && (details.previousRecommendedMax || details.previousRecommendedMax === 0)
					? details.previousRecommendedMax
					: details.recommendedMax);
				var hasMin = false;
				if (details && (minVariable !== proposedMinVariable)) {
					hasMin = true;
					recommendationText += 'min from ' + formatterService.formatDecimal(minVariable, 0) +
						' to ' + formatterService.formatDecimal(proposedMinVariable, 0);
				}
				if (details && (maxVariable !== proposedMaxVariable)) {
					recommendationText += (hasMin ? ', max from ' : 'max from ') +
						formatterService.formatDecimal(maxVariable, 0) + ' to ' +
						formatterService.formatDecimal(proposedMaxVariable, 0);
				}
			}
			return recommendationText;
		}

		function getRopResizeRecommendationText(details) {
			var recommendationText = 'Change ';
			var hasValidReorderPoint = true;
			var hasValidReorderQty = true;
			if ((status === 'Fixed' && (!details || !(details.previousReorderPoint || details.previousReorderPoint === 0)))
				|| (status === 'Expired' && (!details || !(details.previousRecommendedReorderPoint || details.previousRecommendedReorderPoint === 0)))) {
				hasValidReorderPoint = false;
			}
			if ((status === 'Fixed' && (!details || !(details.previousReorderQty || details.previousReorderQty === 0)))
				|| (status === 'Expired' && (!details || !(details.previousRecommendedReorderQty || details.previousRecommendedReorderQty === 0)))) {
				hasValidReorderQty = false;
			}
			if (!hasValidReorderPoint && !hasValidReorderQty) {
				recommendationText = 'Reorder Point Resize';
			} else {
				var reorderPointVariable = (status === 'Fixed' && (details.previousReorderPoint || details.previousReorderPoint === 0)
					? details.previousReorderPoint
					: details.currentReorderPoint);
				var proposedReorderPointVariable = (status === 'Expired' && (details.previousRecommendedReorderPoint || details.previousRecommendedReorderPoint === 0)
					? details.previousRecommendedReorderPoint
					: details.recommendedReorderPoint);
				var reorderQtyVariable = (status === 'Fixed' && (details.previousReorderQty || details.previousReorderQty === 0)
					? details.previousReorderQty
					: details.currentReorderQty);
				var proposedReorderQtyVariable = (status === 'Expired' && (details.previousRecommendedReorderQty || details.previousRecommendedReorderQty === 0)
					? details.previousRecommendedReorderQty
					: details.recommendedReorderQty);
				var hasReorderPoint = false;
				if (details && (reorderPointVariable !== proposedReorderPointVariable)) {
					hasReorderPoint = true;
					recommendationText += 'reorder point from ' + formatterService.formatDecimal(reorderPointVariable, 0) +
						' to ' + formatterService.formatDecimal(proposedReorderPointVariable, 0);
				}
				if (details && (reorderQtyVariable !== proposedReorderQtyVariable)) {
					recommendationText += (hasReorderPoint ? ', reorder quantity from ' : 'reorder quantity from ') +
						formatterService.formatDecimal(reorderQtyVariable, 0) + ' to ' +
						formatterService.formatDecimal(proposedReorderQtyVariable, 0);
				}
			}
			return recommendationText;
		}

		function getPOForExcessRecommendationText(details) {
			return 'POs to Action: Next 6 Months';
		}

		function getPOForExcessLeadTimeRecommendationText(details) {
			var savingsDate = new moment(details.savingsDate);
			return 'POs to Action: ' + savingsDate.format('MMMM YYYY');
		}

		function getPoReductionRecommendationText(details) {
			var baseText = 'PO Actions: Reduce Inventory in ';
			if (details.periodType === 'month') {
				var savingsDate = new moment(details.targetDate);
				return baseText + savingsDate.format('MMMM YYYY');
			} else if (details.periodType === 'quarter') {
				return baseText + 'Q' + details.fiscalPeriod + ' ' + details.fiscalYear;
			} else {
				return baseText + 'H' + details.fiscalPeriod + ' ' + details.fiscalYear;
			}
		}

		function getExcessToSellRecommendationText(details) {
			return 'Sell or Transfer Excess';
		}

		function getHistory(siteId, itemId) {
			var url = String.format(URLS.host + URLS.InventoryActionHistory,
				siteId, itemId);

			return $http.get(url)
				.then(getInventoryActionsHistoryDataComplete)
				.catch(getInventoryActionsHistoryDataFailed);

			function getInventoryActionsHistoryDataComplete(response) {
				if (response && response.data) {
					return response.data;
				}
				return [];
			}
			function getInventoryActionsHistoryDataFailed(error) {
				return error;
			}
		}

		function saveInventoryActionValidSavings(siteId, inventoryActionId, hasValidSavings, invalidComment) {
			var url = String.format(URLS.host + URLS.inventoryActionValidSavings, siteId);
			var updateObject = {
				inventoryActionId: inventoryActionId,
				hasValidSavings: hasValidSavings,
				comment: invalidComment
			};
			return $http.put(url, updateObject)
				.then(saveValidSavingsSuccess)
				.catch(saveValidSavingsFailed);

			function saveValidSavingsSuccess(response) {
				if (response && response.data) {
					return response.data;
				}
				return [];
			}
			function saveValidSavingsFailed(error) {
				return error;
			}
		}
	}
})();
